(function () {
  'use strict';

  angular.module('sempraWebapp').service('washBoxUtils', washBoxUtilsService);

  /** @ngInject */
  function washBoxUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getWashBoxPoint = function (facilityJson, boxName) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.WASH_BOX
          && pointJson.name === boxName;
      });
    };

    this.getWashBoxPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType === PointTypeEnum.WASH_BOX);
      });
    };

    this.getListenerPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType !== PointTypeEnum.WASH_BOX && pointJson.pointType !== PointTypeEnum.SUBSYSTEM);
      });
    };

    this.getListenerWashBoxPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType === PointTypeEnum.WASH_BOX);
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_OTB_PUMPA_GRESKA_MZS: 'OP_OTB_PUMPA_GRESKA_MZS',
      OPW_ALARM_VISOKOTL_PUMPA: 'OPW_ALARM_VISOKOTL_PUMPA',
      OP_CLEAN_BROJ_MIN_RADA: 'OP_CLEAN_BROJ_MIN_RADA',
      OP_CLEAN_BROJ_SATI_RADA: 'OP_CLEAN_BROJ_SATI_RADA',
      OP_VISKTL_BROJ_SATI_RADA: 'OP_VISKTL_BROJ_SATI_RADA',
      OP_VISKTL_RESET_SATI_RADA: 'OP_VISKTL_RESET_SATI_RADA',
      properties: {
        OP_OTB_PUMPA_GRESKA_MZS: getFeedPropertiesObject('OP_OTB_PUMPA_GRESKA_MZS'),
        OPW_ALARM_VISOKOTL_PUMPA: getFeedPropertiesObject('OPW_ALARM_VISOKOTL_PUMPA'),
        OP_CLEAN_BROJ_MIN_RADA: getFeedPropertiesObject('OP_CLEAN_BROJ_MIN_RADA'),
        OP_CLEAN_BROJ_SATI_RADA: getFeedPropertiesObject('OP_CLEAN_BROJ_SATI_RADA'),
        OP_VISKTL_BROJ_SATI_RADA: getFeedPropertiesObject('OP_VISKTL_BROJ_SATI_RADA'),
        OP_VISKTL_RESET_SATI_RADA: getFeedPropertiesObject('OP_VISKTL_RESET_SATI_RADA')
      }

    });

    this.ActuatorReferences = Object.freeze({
      OP_BUTTON_CLEAN: 'OP_BUTTON_CLEAN',
      OP_CC_KOVANICE_RESET: 'OP_CC_KOVANICE_RESET',
      OP_CC_ZETONI_RESET: 'OP_CC_ZETONI_RESET',
      OP_CC_KEY_KREDIT_RESET: 'OP_CC_KEY_KREDIT_RESET',
      OP_BUTTON : 'OP_BUTTON',
      OP_CLEAN_BROJ_SATI_RADA : 'OP_CLEAN_BROJ_SATI_RADA',

      properties: {
        OP_BUTTON_CLEAN: getActuatorPropertiesObject('OP_BUTTON_CLEAN'),
        OP_CC_KOVANICE_RESET: getActuatorPropertiesObject('OP_CC_KOVANICE_RESET'),
        OP_CC_ZETONI_RESET: getActuatorPropertiesObject('OP_CC_ZETONI_RESET'),
        OP_CC_KEY_KREDIT_RESET: getActuatorPropertiesObject('OP_CC_KEY_KREDIT_RESET'),
        OP_BUTTON: getActuatorPropertiesObject('OP_BUTTON'),
        OP_CLEAN_BROJ_SATI_RADA: getActuatorPropertiesObject('OP_CLEAN_BROJ_SATI_RADA')
        }
    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (washBoxPointJson) {
          return modelUtils.getFeedCurrentValue(washBoxPointJson, feedReference);
        },
        getFeed: function (washBoxPointJson) {
          return modelUtils.getFeed(washBoxPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (washBoxPointJson) {
          return modelUtils.getActuatorCurrentValue(washBoxPointJson, actuatorReference);
        },
        getActuator: function (washBoxPointJson) {
          return modelUtils.getActuator(washBoxPointJson, actuatorReference);
        }
      }
    }
  }
})();
